import {
  Container,
  Stack,
  Box,
  Text,
  Heading,
  HStack,
  Divider,
  Card,
  CardBody,
  Badge,
  Wrap,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import t from "../translations";

export default function Education({ color = "purple" }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.400");

  return (
    <Container maxW="4xl" id="education" py={{ base: 16, md: 24 }}>
      <Stack spacing={{ base: 6, md: 10 }}>
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text fontWeight={800} fontSize={{ base: "xl", md: "2xl" }} whiteSpace="nowrap">
              {t.education.heading}
            </Text>
          </HStack>
          <Divider />
        </Stack>

        {t.education.entries.map((entry, index) => (
          <motion.div
            key={entry.institution}
            ref={ref}
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{
              duration: 0.5,
              delay: index * 0.15,
              ease: "easeOut",
            }}
          >
            <Card bg={cardBg} borderRadius="xl" mx={4}>
              <CardBody>
                <Stack spacing={4}>
                  <HStack justify="space-between" flexWrap="wrap" gap={2}>
                    <Box>
                      <Heading size={{ base: "sm", md: "md" }}>{entry.institution}</Heading>
                      <Text color={`${color}.400`} fontWeight={600} mt={1}>
                        {entry.degree}
                      </Text>
                    </Box>
                    <Badge
                      colorScheme={color}
                      borderRadius="full"
                      px={3}
                      py={1}
                      fontSize="sm"
                    >
                      {entry.duration}
                    </Badge>
                  </HStack>
                  <Text color={textColor} fontSize="md" lineHeight={1.8}>
                    {entry.description}
                  </Text>
                  <Wrap spacing={2}>
                    {entry.highlights.map((item) => (
                      <Badge
                        key={item}
                        colorScheme="gray"
                        fontSize="xs"
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {item}
                      </Badge>
                    ))}
                  </Wrap>
                </Stack>
              </CardBody>
            </Card>
          </motion.div>
        ))}
      </Stack>
    </Container>
  );
}
